import data from '../../../data/ranking_data.json'
import spp from '../../../data/ranking_spp.json'

const smData = data.sm
const cities = data.cities
export const research = data.research

/**
 * @param {string[]} categories
 */
export function filterByCategory(categories) {
    const filtered = smData.filter(sm => categories.includes(sm[1] + ""));

    const cityData = {};
    filtered.forEach(([city, metric, value]) => {
        if (!cityData[city])
            cityData[city] = cities[city]
        categories.forEach(category => {
            if (metric === category) {
                cityData[city][category] = value;
            }
        })
    });

    return Object.entries(cityData)
        .map(([city, data]) => ({
            city: city,
            ...data
        }))
}

export function getSPP() {
    return spp.map(c => ({
        city: c[0],
        metric: c[1],
        year: c[2],
        value: c[3],
        isEstimate: c[4] ?? false
    }))
}

export function getSMSizes() {
    const sizes = filterByCategory(['Budżet', 'Etaty: liczba strażników', 'Liczba mieszkańców'])
    sizes.forEach(sm => {
        sm.guardsPer100k = Math.round((sm['Etaty: liczba strażników'] / sm['Liczba mieszkańców']) * 100000 * 10) / 10
    })
    sizes.forEach(sm => {
        sm.budgetPerCitizen = Math.round((sm['Budżet'] / sm['Liczba mieszkańców']) * 10) / 10
    })
    return sizes.sort((a, b) => b.budgetPerCitizen - a.budgetPerCitizen)
}


